export default {
  mounted() {
    if (
      window.BOLD
      && window.BOLD.subscriptions
      && window.BOLD.subscriptions.bootCustomerPortal
    ) {
      // Boot customer portal on route change. The normal trigger is a page load.
      window.BOLD.subscriptions.bootCustomerPortal();
    }
  },
};
